import { useAuthStore } from "../store/useAuthStore";

export type LiveclassStudentSyncPayload = {
  studentID: number;
  firstName: string;
  lastName: string;
  grade: number;
  phone: string;
  countryCode: string;
  userType: number;
  profilePhoto: string | null;
  tenant: string;
  roles: Array<{
    role_id: number;
    role_name: string;
    created_time: number;
    role_code: string;
    display_name: string;
    active: boolean;
  }>;
};

export const buildLiveclassStudentSyncPayload =
  (): LiveclassStudentSyncPayload | null => {
    const { profilesData } = useAuthStore.getState();
    const unified = profilesData?.unified_account_details;
    const user = unified?.user_account_details;
    const profiles = unified?.profiles ?? [];

    if (!unified || !user || profiles.length === 0) return null;

    const defaultProfile =
      profiles.find((p) => p.is_default_profile) ?? profiles[0];
    const uamId = defaultProfile?.uam_id;

    if (uamId == null) return null;

    const role = user.role;

    return {
      studentID: Number(uamId),
      firstName: user.first_name ?? "",
      lastName: user.last_name ?? "",
      grade: user.grade?.gradeId ?? 0,
      phone: user.phone ?? "",
      countryCode: user.isd_code ?? "+91",
      userType: user.user_type?.user_type_id ?? 1,
      profilePhoto: user.profile_photo ?? null,
      tenant: "infinitylearn",
      roles: role
        ? [
            {
              role_id: role.role_id,
              role_name: role.role_name,
              created_time: role.created_time,
              role_code: role.role_code,
              display_name: role.role_name,
              active: true,
            },
          ]
        : [],
    };
  };
